/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

document.addEventListener("DOMContentLoaded", function () {
  // Custom JS for controling the PDP ATC text/popups when out of stock
  const selectElement = document.querySelector("select#Size");
  const addToCartButton = document.querySelector(
    ".product__add-to-cart-button"
  );
  const popupElement = document.querySelector(".popup.make-my-x__popup");
  if (addToCartButton) {
    addToCartButton.addEventListener("click", function () {
      // Check if the cart text doesn't equal 'view cart'
      if (
        addToCartButton.innerText.trim().toLowerCase() == "make my ring" ||
        addToCartButton.innerText.trim().toLowerCase() == "make my thing"
      ) {
        popupElement.classList.remove("hide");
      }
    });
  }
  if (popupElement) {
    popupElement
      .querySelector(".close_button")
      .addEventListener("click", function () {
        popupElement.classList.add("hide");
      });
  }

  if (selectElement) {
    selectElement.addEventListener("change", function () {
        const selectedOption = selectElement.options[selectElement.selectedIndex];

        // Handle the made-to-order case
        if (
            selectedOption &&
            selectedOption.getAttribute("data-made-to-order") === "true"
        ) {
            // Update button text to 'MAKE MY RING' or 'MAKE MY THING'
            addToCartButton.innerText = "MAKE MY THING";
            console.log("Setting MAKE MY THING");
        }
    });
}

});




// Custom code to convert pagination
let pageNumbers = document.querySelectorAll('.pagination__page')
let firstPage = false
if(!window.location.href.includes('?page')){
    firstPage = true;
}
pageNumbers.forEach(element => {
    if(window.location.href.includes(element) || firstPage){
        element.classList.add('disabled');
        firstPage = false;
    }

    element.innerHTML = toRoman(element.innerHTML);
});

function toRoman(num) {
    const romanNumerals = {
        M: 1000,
        CM: 900,
        D: 500,
        CD: 400,
        C: 100,
        XC: 90,
        L: 50,
        XL: 40,
        X: 10,
        IX: 9,
        V: 5,
        IV: 4,
        I: 1
    };

    let result = '';

    for (let key in romanNumerals) {
        while (num >= romanNumerals[key]) {
            result += key;
            num -= romanNumerals[key];
        }
    }

    return result;
}